import './HeaderWrapper.scss'
import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";
import React from "react";
import {connect} from "react-redux";
import {getPropsFromState} from "../../redux/mapStateToProps";
import {HeaderBg} from "../../assets/images";


function HeaderWrapper(props) {
    const {staticTexts, addressFirst, title, withBg = true, rightPartJsx} = props

    return <div className={`header-wrapper ${withBg ? '' : 'hide-bg'}`}>
        {withBg && <img src={HeaderBg}
                        alt=""
                        className="header-wrapper-img"/>}
        <div className={'routs-wrapper'}>
            <div className="overlay"/>
            <Breadcrumb>
                <Breadcrumb.Item><Link
                    to={getUrlWithLocal('/home')}>{staticTexts?.rout_item_home}</Link></Breadcrumb.Item>
                <Breadcrumb.Item>{addressFirst}</Breadcrumb.Item>
            </Breadcrumb>
            {rightPartJsx && <div className={'route-right-part'}>{rightPartJsx}</div>}
        </div>
        <div className="header-wrapper-title">{title}</div>
    </div>
}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
]);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
